import { Container, Grid, MenuItem } from "@mui/material";
import React, { useState } from "react";
import { CloseIcon } from "../../../../../styles/img/svg/CloseIcon";
import { useNavigate } from "react-router-dom";
import { BackIcon } from "../../../../../styles/img/svg/BackIcon";
import { ResetPasswordForm } from "../resetPassword/ResetPasswordForm";
import { useTranslation } from "react-i18next";
import { ForgotPasswordLeavePopup } from "../../views/popups/ForgotPasswordLeavePopup";
import { ConfirmationIcon } from "../../../../../styles/img/svg/ConfirmationIcon";
import { UiPopup } from "../../../../_uiComponents/common/UiModal";

export const ResetPassword = (props) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [showLeavingPopup, setShowLeavingPopup] = useState(false);

  const backtoHome = () => {
    setShowLeavingPopup(true);
  };

  const backtoResetUsername = () => {
    setShowLeavingPopup(true);
  };

  const okBtnHandler = () => {
    navigate("/");
  };

  return (
    <>
      <div className="df-user-profile df-reset-cd-form df-profile-top-aligned-box">
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile__close-icon" onClick={backtoHome}>
            <CloseIcon />
          </div>

          <div
            className="df-user-profile__back-icon"
            onClick={backtoResetUsername}
          >
            <BackIcon />
          </div>
          <div className="df-user-profile__body df-pw-tab df-card-details-tb df-pw-reset-tb">
            <Grid container>
              <Grid size={12} className="text-right df-pl-2">
                <h2 className="df-reset-pw-title text-center">
                  {t("Enter a password for your digital banking account")}
                </h2>
                <ResetPasswordForm />
              </Grid>
            </Grid>
          </div>
        </Container>
      </div>
      <UiPopup
        openModal={showLeavingPopup}
        handleClose={() => {
          setShowLeavingPopup(false);
        }}
      >
        <ForgotPasswordLeavePopup
          icon={<ConfirmationIcon />}
          message={t("Leaving this page?")}
          buttonText={t("Leave")}
          buttonOnClickClose={() => {
            setShowLeavingPopup(false);
          }}
          buttonOnClick={okBtnHandler}
          className="df-confirmation-message-popup df-btn-grpdmodal"
        >
          <p>
            {t(
              "Are you sure you want to leave this page? You have some unsaved changes.",
            )}
          </p>
        </ForgotPasswordLeavePopup>
      </UiPopup>
    </>
  );
};
